"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM9.85,15.75h-1a.31.31,0,0,1-.22-.1L6.48,13.42v2.1a.24.24,0,0,1-.23.23h-.7a.24.24,0,0,1-.23-.23V7.58a.24.24,0,0,1,.23-.23h.7a.24.24,0,0,1,.23.23v5.19l1.87-1.68a.47.47,0,0,1,.3-.14h.84a.19.19,0,0,1,.13.32l-2,1.81L10,15.44A.18.18,0,0,1,9.85,15.75Zm8.83-.23a.23.23,0,0,1-.23.23h-.67a.23.23,0,0,1-.23-.23V13.06c0-.76-.35-1.19-1-1.19a1.73,1.73,0,0,0-1.24.59,3.3,3.3,0,0,1,0,.58v2.48a.24.24,0,0,1-.23.23H14.5a.23.23,0,0,1-.23-.23V13.06c0-.77-.35-1.19-1-1.19a1.36,1.36,0,0,0-1.19.72v2.93a.24.24,0,0,1-.23.23h-.67a.24.24,0,0,1-.23-.23V11.18a.24.24,0,0,1,.23-.23h.34a.21.21,0,0,1,.2.14l.13.41a2.23,2.23,0,0,1,1.58-.67A1.78,1.78,0,0,1,15,11.6a2.67,2.67,0,0,1,1.74-.77c1.46,0,2,1,2,2.28Z"
  }));
};

exports["default"] = _default;